import React from 'react';
import Sign from '../Icons/Sign';

const CheckboxUncheckedSign = ({ style, }) => <div className="fake-button" style={style}><Sign glyph="CHECKBOX_UNCHECKED"/></div>;

export default CheckboxUncheckedSign;